var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgULockAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_28_4845)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 11.616V10.6667C18.6668 8.08934 16.5775 6 14.0002 6C11.4228 6 9.3335 8.08934 9.3335 10.6667V11.616C8.12018 12.1455 7.33525 13.3428 7.3335 14.6667V18.6667C7.33568 20.5067 8.82678 21.9978 10.6668 22H17.3335C19.1735 21.9978 20.6646 20.5067 20.6668 18.6667V14.6667C20.6651 13.3428 19.8801 12.1455 18.6668 11.616ZM14.6668 17.3333C14.6668 17.7015 14.3683 18 14.0002 18C13.632 18 13.3335 17.7015 13.3335 17.3333V16C13.3335 15.6318 13.632 15.3333 14.0002 15.3333C14.3683 15.3333 14.6668 15.6318 14.6668 16V17.3333ZM17.3335 11.3333H10.6668V10.6667C10.6668 8.82575 12.1592 7.33334 14.0002 7.33334C15.8411 7.33334 17.3335 8.82572 17.3335 10.6667V11.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4845",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgULockAlt);
export default __webpack_public_path__ + "static/media/u_lock-alt.bc8fbb8db06c6a3a667b54e41250b1dd.svg";
export { ForwardRef as ReactComponent };